import Mock from '@/mocks/Mock'
import History, { HistoryAttributes } from '@/models/History'
import { HistoryParams } from '@/repositories/history-repository'

export default class HistoryMock extends Mock<HistoryAttributes> {
  constructor() {
    super('history')
  }

  get(params: HistoryParams) {
    console.log(params)

    return new History(this.data)
  }
}
